import "./NoPage.css";

function NoPage() {
  return <h2>Error 404: Not found!!!</h2>;
}

export default NoPage;
